<template>
  <div class="bcb-customer-exam-result container-fluid">
    <div class="d-flex align-items-center my-6">
      <div class="flex-grow-1">
        <h4 class="text-dark fw-bold mb-1">Ket qua kham</h4>
        <p class="text-muted m-0">BCB Bundle Campaign</p>
      </div>
    </div>

    <b-overlay :show="loading">
      <div class="bg-white rounded border p-5">
        <div v-if="results.length" class="exam-result-list">
          <div
            v-for="(result, idx) in results"
            :key="result.id || idx"
            class="exam-result-item"
          >
            <div class="exam-result-item__index">{{ idx + 1 }}</div>
            <div class="exam-result-item__info">
              <div class="exam-result-item__name">
                <i class="fas fa-file-alt mr-1 text-primary"></i>
                <span class="font-weight-bold">{{ result.additionalServices || 'Ket qua kham' }}</span>
              </div>
              <div class="exam-result-item__meta">
                <span>
                  <i class="fas fa-tag mr-1 text-warning"></i>
                  {{ examTypeLabel(result.type) }}
                </span>
                <span class="ml-3">
                  <i class="fas fa-calendar-upload mr-1 text-muted"></i>
                  {{ formatDateTime(result.uploadedAt) }}
                </span>
              </div>
              <div v-if="result.saleNote" class="exam-result-item__note">
                <i class="fas fa-sticky-note mr-1 text-muted"></i>{{ result.saleNote }}
              </div>
            </div>
            <button
              v-if="result.fileUrl"
              class="btn btn-outline-primary btn-sm ml-auto"
              @click="openOriginalFile(result)"
            >
              <i class="fas fa-file-pdf mr-1"></i>Xem file
            </button>
          </div>
        </div>
        <div v-else class="text-muted text-center py-5">
          <i class="fas fa-folder-open mr-2"></i>Chua co ket qua kham.
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { BCB_EXAM_RESULT_TYPE } from '../constants/index.js';

export default {
  name: 'BcbCustomerExamResultView',
  props: {
    campaignCustomerId: { type: [String, Number], default: null },
  },
  data() {
    return {
      loading: false,
      results: [],
    };
  },
  computed: {
    resolvedCampaignCustomerId() {
      return this.campaignCustomerId || this.$route.params.campaignCustomerId;
    },
  },
  created() {
    this.loadResults();
  },
  methods: {
    async loadResults() {
      if (!this.resolvedCampaignCustomerId) return;
      this.loading = true;
      try {
        const res = await this.$api.get(`BcbExamResult/campaign-customer/${this.resolvedCampaignCustomerId}`);
        const raw = res?.data ?? res;
        this.results = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
      } catch (e) {
        this.$toastr.e({ title: 'Loi', msg: e?.message || 'Khong the tai ket qua kham.' });
      } finally {
        this.loading = false;
      }
    },
    examTypeLabel(type) {
      return BCB_EXAM_RESULT_TYPE[type] || 'Khac';
    },
    openOriginalFile(result) {
      if (!result?.fileUrl) return;
      window.open(result.fileUrl, '_blank');
    },
    formatDateTime(val) {
      if (!val) return '---';
      if (typeof val === 'number') {
        return this.$moment.unix(val).utcOffset('+07:00').format('DD/MM/YYYY HH:mm');
      }
      return this.$moment(val).utcOffset('+07:00').format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>

<style scoped lang="scss">
.exam-result-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.exam-result-item {
  align-items: flex-start;
  background: #f9fbff;
  border: 1px solid #e4e6ef;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  padding: 14px;

  &__index {
    align-items: center;
    background: #009ef7;
    border-radius: 50%;
    color: #fff;
    display: flex;
    flex-shrink: 0;
    font-size: 0.78rem;
    font-weight: 700;
    height: 26px;
    justify-content: center;
    margin-top: 2px;
    width: 26px;
  }

  &__info {
    flex: 1;
    min-width: 0;
  }

  &__name {
    color: #181c32;
    font-size: 0.95rem;
    margin-bottom: 4px;
  }

  &__meta,
  &__note {
    color: #7e8299;
    font-size: 0.82rem;
  }
}
</style>
